// Featured cars sourced from live MotoStream listings (developer-managed).

export const FEATURED_CAR_BASE_URL = 'https://www.motostream.app';

export const FEATURED_CARS_PAGE_SIZE = 4;

export const LOWEST_PRICE_MIN_USD = 10;
export const LOWEST_PRICE_MAX_USD = 100;
export const LUXURY_PRICE_MIN_USD = 300;
export const LUXURY_PRICE_MAX_USD = 10000;

export const PRICE_POPOVER_FILTERS = ['lowestPrices', 'luxury'];

export const FEATURED_PRICE_SLIDER_MAX = 10000;

export const getFeaturedPriceRange = (filterKey) => {
  if (filterKey === 'lowestPrices') {
    return [LOWEST_PRICE_MIN_USD, LOWEST_PRICE_MAX_USD];
  }
  if (filterKey === 'luxury') {
    return [LUXURY_PRICE_MIN_USD, LUXURY_PRICE_MAX_USD];
  }
  return null;
};

export const createDefaultPriceRanges = () => ({
  lowestPrices: getFeaturedPriceRange('lowestPrices'),
  luxury: getFeaturedPriceRange('luxury'),
});

export const getListingPhoto = (listPhotos, coverPhoto) => {
  if (!listPhotos || !listPhotos.length) {
    return null;
  }

  let photo = listPhotos[0].name;

  if (coverPhoto != null) {
    const match = listPhotos.find((item) => item.id === coverPhoto);
    if (match) {
      photo = match.name;
    }
  }

  return photo;
};

export const getFeaturedCarImagePath = (photo, size = 'x_medium') => (
  photo ? `${FEATURED_CAR_BASE_URL}/images/upload/${size}_${photo}` : null
);

const toDailyPriceUsd = (basePrice, currency) => {
  if (currency === 'USD') {
    return basePrice;
  }
  if (currency === 'EUR') {
    return Math.round(basePrice * 1.08);
  }
  if (currency === 'AMD') {
    return Math.round(basePrice * 0.0026);
  }
  return basePrice;
};

export const filterFeaturedCarsByPrice = (minUsd, maxUsd) => (
  FEATURED_CARS.filter(
    (car) => car.dailyPriceUsd >= minUsd && car.dailyPriceUsd <= maxUsd,
  )
);

export const filterFeaturedCarsByMinPrice = (minUsd) => (
  FEATURED_CARS.filter((car) => car.dailyPriceUsd >= minUsd)
);

export const NEWEST_FILTER_LIMIT = 3;
export const RENTERS_FAVOURITES_FILTER_LIMIT = 6;
export const MOST_POPULAR_FILTER_LIMIT = 5;

export const filterFeaturedCarsByFlag = (flag, limit) => (
  FEATURED_CARS.filter((car) => car[flag]).slice(0, limit)
);

export const FEATURED_CAR_FILTERS = [
  { key: 'all', icon: 'filter' },
  { key: 'rentersFavourites', icon: 'heart' },
  { key: 'mostPopular', icon: 'popular' },
  { key: 'newest', icon: 'new' },
  { key: 'lowestPrices', icon: 'price' },
  { key: 'luxury', icon: 'luxury' },
];

export const FEATURED_CARS = [
  {
    id: '85',
    listId: 85,
    titleMessageKey: 'newLandingCarKiaSportage',
    title: 'Kia Sportage: Your Ultimate Drive',
    href: `${FEATURED_CAR_BASE_URL}/cars/kia-sportage:-your-ultimate-drive-85`,
    coverPhoto: null,
    listPhotos: [
      { id: 227, name: 'abd3f16d56c54f5bb854873a3f381724.jpeg' },
      { id: 228, name: '64dd1710e07b7e467c9e63956edada52.jpeg' },
    ],
    basePrice: 58.37,
    currency: 'USD',
    displayRating: '4.92',
    displayReviews: 38,
    rentersFavourite: true,
    wishListStatus: false,
  },
  {
    id: '140',
    listId: 140,
    titleMessageKey: 'newLandingCarTRocSimilar',
    title: 'T-Roc Auto',
    href: `${FEATURED_CAR_BASE_URL}/cars/-t-roc-auto-or-similar-140`,
    coverPhoto: null,
    listPhotos: [{ id: 307, name: 'dd5249daf38d14a8eefe3402cb3135aa.jpeg' }],
    basePrice: 58.37,
    currency: 'USD',
    displayRating: '4.98',
    displayReviews: 62,
    newest: true,
    rentersFavourite: true,
    mostPopular: true,
    wishListStatus: false,
  },
  {
    id: '135',
    listId: 135,
    titleMessageKey: 'newLandingCarCitroenC4',
    title: 'Citroen C4 Auto',
    href: `${FEATURED_CAR_BASE_URL}/cars/citroen-c4-auto-135`,
    coverPhoto: null,
    listPhotos: [{ id: 302, name: '2dd0be3c6498e2b21b924296ad2ee5d8.jpeg' }],
    basePrice: 52.53,
    currency: 'USD',
    displayRating: '4.85',
    displayReviews: 41,
    mostPopular: true,
    wishListStatus: false,
  },
  {
    id: '137',
    listId: 137,
    titleMessageKey: 'newLandingCarTRocAuto',
    title: 'T-Roc Auto',
    href: `${FEATURED_CAR_BASE_URL}/cars/t-roc-auto--137`,
    coverPhoto: null,
    listPhotos: [{ id: 304, name: '05291841d7a7d823b4184c6e72018f6f.jpeg' }],
    basePrice: 58.37,
    currency: 'USD',
    displayRating: '4.91',
    displayReviews: 55,
    newest: true,
    mostPopular: true,
    wishListStatus: false,
  },
  {
    id: '134',
    listId: 134,
    titleMessageKey: 'newLandingCarCitroenC3Similar',
    title: 'Citroën C3 Auto',
    href: `${FEATURED_CAR_BASE_URL}/cars/citroën-c3-auto-or-similar-134`,
    coverPhoto: null,
    listPhotos: [{ id: 301, name: '144d156466f09e7f0c65e6b6da31f4ad.jpeg' }],
    basePrice: 40.86,
    currency: 'USD',
    displayRating: '4.88',
    displayReviews: 29,
    wishListStatus: false,
  },
  {
    id: '128',
    listId: 128,
    titleMessageKey: 'newLandingCarHyundaiAccent',
    title: 'Hyundai Accent Auto',
    href: `${FEATURED_CAR_BASE_URL}/cars/hyundai-accent-auto-or-similar-128`,
    coverPhoto: null,
    listPhotos: [{ id: 295, name: 'b5f09e99b22cf57c07dfef5bab8af014.jpeg' }],
    basePrice: 35.02,
    currency: 'USD',
    displayRating: '4.95',
    displayReviews: 73,
    rentersFavourite: true,
    mostPopular: true,
    wishListStatus: false,
  },
  {
    id: '118',
    listId: 118,
    titleMessageKey: 'newLandingCarHyundaiTucson',
    title: 'Hyundai Tucson Full Option',
    href: `${FEATURED_CAR_BASE_URL}/cars/hyundai-tucson-full-option-or-similar-118`,
    coverPhoto: null,
    listPhotos: [{ id: 285, name: 'ae0f9f039d7f063130397772ff091529.jpeg' }],
    basePrice: 70.04,
    currency: 'USD',
    displayRating: '4.90',
    displayReviews: 47,
    mostPopular: true,
    wishListStatus: false,
  },
  {
    id: '27',
    listId: 27,
    titleMessageKey: 'newLandingCarAudiQ8Urban',
    title: 'Audi Q8',
    href: `${FEATURED_CAR_BASE_URL}/cars/the-urban-voyager:-audi-q8-27`,
    coverPhoto: 101,
    listPhotos: [
      { id: 99, name: 'c267570a398d0cd75af23c57e5f89322.jpeg' },
      { id: 100, name: '69abb7544e69900644277418a555192f.jpeg' },
      { id: 101, name: '3f629d8c47b1703a1176528223ab91cc.jpeg' },
      { id: 102, name: 'e9b8b65b3b7c001cb3ba0e2ebc45dfdb.jpeg' },
      { id: 103, name: '3f5fe9b650705dbbfbfec6849fc25cbd.jpeg' },
      { id: 104, name: '289204537d3389bfd2a50648001fa137.jpeg' },
      { id: 105, name: '555dcde067cab3eba5911b90ee31b09e.jpeg' },
    ],
    basePrice: 291.84,
    currency: 'USD',
    displayRating: '5.0',
    displayReviews: 18,
    rentersFavourite: true,
    wishListStatus: false,
  },
  {
    id: '43',
    listId: 43,
    titleMessageKey: 'newLandingCarAudiQ8Prestige',
    title: 'Audi Q8 Prestige',
    href: `${FEATURED_CAR_BASE_URL}/cars/q8:-power-and-prestige-43`,
    coverPhoto: null,
    listPhotos: [
      { id: 137, name: '1c94e7c1f6bb82ea000922db07eea28f.jpeg' },
      { id: 138, name: 'dc4e973ec3c8e84a1a54e9e0cea4abdc.jpeg' },
      { id: 139, name: '9ea0f3bfb4933ab40e0f5917ced0f30a.jpeg' },
    ],
    basePrice: 291.84,
    currency: 'USD',
    displayRating: '4.97',
    displayReviews: 24,
    rentersFavourite: true,
    wishListStatus: false,
  }
].map((car) => ({
  ...car,
  photo: getListingPhoto(car.listPhotos, car.coverPhoto),
  dailyPriceUsd: toDailyPriceUsd(car.basePrice, car.currency),
  rating: car.displayRating,
  reviews: String(car.displayReviews),
}));

export const getFilteredFeaturedCars = (activeFilter) => {
  let cars;

  switch (activeFilter) {
    case 'lowestPrices':
      cars = filterFeaturedCarsByPrice(LOWEST_PRICE_MIN_USD, LOWEST_PRICE_MAX_USD);
      break;
    case 'luxury':
      cars = filterFeaturedCarsByMinPrice(LUXURY_PRICE_MIN_USD);
      break;
    case 'newest':
      cars = filterFeaturedCarsByFlag('newest', NEWEST_FILTER_LIMIT)
        .sort((a, b) => b.listId - a.listId);
      break;
    case 'rentersFavourites':
      cars = filterFeaturedCarsByFlag('rentersFavourite', RENTERS_FAVOURITES_FILTER_LIMIT);
      break;
    case 'mostPopular':
      cars = filterFeaturedCarsByFlag('mostPopular', MOST_POPULAR_FILTER_LIMIT);
      break;
    case 'all':
    default:
      cars = [...FEATURED_CARS];
      break;
  }

  return cars;
};

export const getFeaturedCarsPage = (cars, pageIndex, pageSize = FEATURED_CARS_PAGE_SIZE) => {
  const start = pageIndex * pageSize;
  return cars.slice(start, start + pageSize);
};

export const getFeaturedCarsTotalPages = (cars, pageSize = FEATURED_CARS_PAGE_SIZE) => (
  Math.max(1, Math.ceil(cars.length / pageSize))
);
